import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Loader2, Check, PenLine, MapPin } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const money = (n) => "$" + Math.round(Number(n || 0)).toLocaleString();

export default function QuotesCompare() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState("");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    axios.get(`${BACKEND}/api/public/quotes/${token}`)
      .then((r) => setData(r.data))
      .catch(() => setErr("对比链接无效或已失效"));
  }, [token]);

  const choose = async (qt) => {
    setBusy(qt);
    try {
      const { data: r } = await axios.post(`${BACKEND}/api/public/estimate/${qt}/request-sign`);
      if (r.hasContract && r.contractToken) window.location.href = `/contract-sign/${r.contractToken}`;
      else setMsg("感谢您的选择！我们的项目顾问将尽快与您联系并准备正式合同。");
    } catch { setMsg("提交失败，请稍后重试。"); }
    setBusy("");
  };

  if (err) return <div className="min-h-screen flex items-center justify-center text-slate-500" data-testid="quotes-compare-error">{err}</div>;
  if (!data) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-brand-500" /></div>;

  const cheapest = Math.min(...(data.quotes || []).map((q) => q.total || Infinity));
  return (
    <div className="min-h-screen bg-slate-100" data-testid="quotes-compare-page">
      <div className="bg-slate-900 text-white px-5 py-4 flex items-center gap-2">
        <span className="font-bold text-red-500 text-lg">ALIGCUS</span>
        <div><p className="text-sm font-semibold">ADU 方案对比 Package Comparison</p><p className="text-[11px] text-slate-300 flex items-center gap-1"><MapPin className="h-3 w-3" />{data.address || data.clientName}</p></div>
      </div>
      <div className="max-w-[980px] mx-auto p-4">
        {msg && <div data-testid="quotes-compare-msg" className="rounded-xl bg-emerald-50 border border-emerald-200 text-emerald-800 px-4 py-3 mb-4 text-center text-sm font-medium">{msg}</div>}
        {data.count === 0 ? (
          <p className="text-center text-slate-400 py-16">暂无可对比的报价方案。</p>
        ) : (
          <div className="grid gap-4" style={{ gridTemplateColumns: `repeat(${Math.min(data.count, 3)}, minmax(0, 1fr))` }}>
            {data.quotes.map((q, i) => {
              const best = q.total === cheapest;
              return (
                <div key={q.token || i} data-testid={`quote-card-${i}`} className={`bg-white rounded-2xl p-5 shadow-sm border-2 ${best ? "border-red-500" : "border-transparent"}`}>
                  {best && <span className="inline-block text-[10px] font-bold text-white bg-red-500 rounded-full px-2 py-0.5 mb-2">最超值 BEST VALUE</span>}
                  <p className="text-base font-bold text-slate-800">{q.packageName}</p>
                  <p className="text-[12px] text-slate-400">{Math.round(q.sf || 0)} sf · {q.layout || "-"}</p>
                  <p className="text-3xl font-extrabold text-red-600 my-3" data-testid={`quote-total-${i}`}>{money(q.total)}</p>
                  <ul className="space-y-1.5 mb-4 min-h-[120px]">
                    {(q.specs || []).slice(0, 8).map((s, j) => (
                      <li key={j} className="flex items-start gap-1.5 text-[12px] text-slate-600"><Check className="h-3.5 w-3.5 text-emerald-500 shrink-0 mt-0.5" />{s}</li>
                    ))}
                  </ul>
                  <button onClick={() => choose(q.token)} disabled={busy === q.token || !q.token} data-testid={`quote-choose-${i}`}
                    className="w-full flex items-center justify-center gap-1.5 bg-brand-500 hover:bg-brand-600 text-white rounded-xl py-2.5 font-semibold text-sm transition-colors disabled:opacity-60">
                    {busy === q.token ? <Loader2 className="h-4 w-4 animate-spin" /> : <><PenLine className="h-4 w-4" />选择此方案签约</>}
                  </button>
                  <a href={`/estimate/${q.token}`} className="block text-center text-[11px] text-slate-400 hover:text-red-600 mt-2">查看详情与 PDF →</a>
                </div>
              );
            })}
          </div>
        )}
        <p className="text-center text-[11px] text-slate-400 py-8">最终价格以现场勘测与正式合同为准。<br />阿里建筑 ALIGCUS · 626-803-8000 / 408-900-6688</p>
      </div>
    </div>
  );
}
